import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './AtHoveServicesView.module.scss';
import BookingExplore from '@booking/pages/bookingHome/BookingExplore';
export const AtHomeServicesView = () => {
    const { t } = useTranslation();
    return (_jsx("div", Object.assign({ className: styles.contentWrapper }, { children: _jsx(BookingExplore, {}) })));
};
